import { randomBytes, createCipheriv, createDecipheriv, createHash, BinaryLike } from 'crypto'
import { valueIsNotNullOrUndefined } from './validations'
import { memoize } from './function'

const setup = memoize(() => {
  const algorithm = 'aes-128-cbc'
  const salt = 'foobar'
  const hash = createHash('sha1')

  hash.update(salt)

  // `hash.digest()` returns a Buffer by default when no encoding is given
  const key = hash.digest().slice(0, 16)
  createHash('sha256').update(String(salt)).digest('base64').slice(0, 32)
  const iv = randomBytes(16)

  return {
    algorithm,
    key,
    iv,
  }
})

export interface EncryptedData {
  iv: string
  encryptedData: string
}

// Encrypting text
export const encrypt = (data: BinaryLike): EncryptedData => {
  const { algorithm, key, iv } = setup()
  const cipher = createCipheriv(algorithm, key, iv)
  let encrypted = cipher.update(data)
  encrypted = Buffer.concat([encrypted, cipher.final()])
  return { iv: iv.toString('hex'), encryptedData: encrypted.toString('hex') }
}

// Decrypting text
export const decrypt = (encryptedObject: EncryptedData | null | undefined): string | null => {
  const { algorithm, key } = setup()
  if (!valueIsNotNullOrUndefined(encryptedObject)) {
    return null
  }

  try {
    const iv = Buffer.from(encryptedObject?.iv ?? '', 'hex')
    const encryptedText = Buffer.from(encryptedObject?.encryptedData ?? '', 'hex')

    const decipher = createDecipheriv(algorithm, key, iv)
    let decrypted = decipher.update(encryptedText)
    decrypted = Buffer.concat([decrypted, decipher.final()])

    return decrypted.toString()
  } catch (error) {
    return null
  }
}
